import React, { Component, Fragment } from 'react';
import { ReactSVG } from 'react-svg';
import { Parallax } from 'react-scroll-parallax';
import Media from 'react-media';
import { getAnalytics, logEvent } from 'firebase/analytics';

import { MOBILE_WIDTH } from '../../constants';
import styles from './Summary.module.scss';
import iosSvg from '../../assets/iosDownload.svg';
import googleBadge from '../../assets/googleBadge.png';
import box from './box-bg.svg';
import outline from './box-outline.svg';
import frameBack from '../../assets/shapes/frameBack.svg';
import frame from '../../assets/shapes/frame.svg';
import appIcon from '../../assets/appIcon.png';

class Intro extends Component {
	render() {
		const {
			container,
			laxContainer,
			laxContainerSM,
			detail,
			detailSM,
			badge,
			boxOutline,
			boxBg,
			text,
			content,
			icn,
			image,
			imageSM,
			appName,
			appNameSM,
			brandFrame,
			brandFrameSM,
			brand,
			brandSM,
		} = styles;
		const analytics = getAnalytics();

		return (
			<div className={container}>
				<Media query={{ maxWidth: MOBILE_WIDTH }}>
					{(matches) => (
						<Fragment>
							<div className={`${matches ? laxContainerSM : laxContainer}`}>
								<ReactSVG src={frameBack} className={boxBg} />

								<Parallax className={text} translateX={[30, -30]} translateY={[70, -70]}>
									<div className={`${matches ? brandFrameSM : brandFrame}`}>
										<div className={icn}>
											<img src={appIcon} width='100%' height='100%' className={`${matches ? imageSM : image}`} alt='' />
										</div>

										<div className={`${matches ? appNameSM : appName}`}>Wake</div>
									</div>
								</Parallax>

								<Parallax className={boxOutline} translateY={[35, -35]}>
									<ReactSVG src={frame} />
								</Parallax>
							</div>
							<div className={content}>
								<div className={`${matches ? detailSM : detail}`}>
									We believe that life is too short to waste it stuck in unwanted routines and ruts.
								</div>
								<div className={`${matches ? detailSM : detail}`}>
									Get your life off of cruise control. Grab the wheel and get somewhere you actually want to be.
								</div>
								<div style={{ display: 'flex', paddingTop: '5rem', flexDirection: 'column', alignItems: 'center' }}>
									<div className={`${matches ? brandSM : brand}`}>Wake: Goal & Habit Tracker</div>

									{matches ? (
										<div style={{ display: 'flex', flexDirection: 'row' }}>
											<button
												onClick={() => {
													logEvent(analytics, 'SummaryIosPressed');

													window.location.href = 'https://appurl.io/zDDmpAjotI';
												}}
											>
												<ReactSVG src={iosSvg} />
											</button>
											<button
												onClick={() => {
													logEvent(analytics, 'SummaryDroidPressed');

													window.location.href = 'https://appurl.io/zDDmpAjotI';
												}}
											>
												<img className={badge} src={googleBadge} alt='google badge' />
											</button>
										</div>
									) : (
										<div className={`${matches ? detailSM : detail}`}>Available on iOS and Android</div>
									)}
								</div>
							</div>
						</Fragment>
					)}
				</Media>
			</div>
		);
	}
}

export default Intro;
